import {
  DeviceAuthenticatorType,
  BiometricEntryPoint,
} from '@shopee/web-bridge-sdk';

export const CHECK_BIOMETRICS_STATUS_NATIVE_COOKIES = ['SPC_DID', 'SPC_F'];

// https://confluence.shopee.io/display/SPAT/WIP+%5BApp%5D+Knowledge+Base+-+ToB+SDK+Biometrics+and+Passcode+Authentication
export enum BiometricStatus {
  Success = 0,

  ErrorActivateManually = 1,
  ErrorUnsupportedBiometric = 2,
  ErrorNoEncryptedData = 3,
  ErrorUserInCooldown = 4,

  // During biometrics project, there are errors with different meaning BUT having the same error code
  // returned from BE and native. Since these errors are returned from web bridge commands, there were no
  // way for FE to differentiate the errors.
  //
  // To fix this issue, Native-related error will use negative value; starting with
  // builds with passcode features. We're keeping the original value due to backward compatibility for build
  // with biometrics feature but without passcode features.
  ErrorActivateManuallyV2 = -1,
  ErrorUnsupportedBiometricV2 = -2,
  ErrorNoEncryptedDataV2 = -3,
  ErrorUserInCooldownV2 = -4,

  // Error code for passcode is disabled in device
  // If passcode is dsiabled, then other biometrics will be disabled as well
  ErrorPasscodeIsDisabledInDevice = -5,

  // Error code for jwt sign failed
  ErrorJwtSignFailed = -2001,

  ErrorUnknown = -10000,
  // this error code will be triggered by touch ID system when user
  // failed to verify biometric for the first time. The system will cancel
  // biometric session and user need to manually trigger the prompt again (e.g. clicking relogin biometric).
  // if user fail to verify the biometric again, they will trigger a lockout
  //
  // on face id system, this won't happen as biometric session is not cancelled by system
  // but instead they're given an option to retry.
  ErrorRetryableSystemCancel = 10006,
  ErrorRetryableSystemCancelV2 = -10006,

  // User action-related error
  ErrorLockoutTemporary = 10007,
  ErrorLockoutPermanent = 10009,
  ErrorUserCancelled = 10010,
  ErrorNegativeButton = 10013,

  // During biometrics project, there are errors with different meaning BUT having the same error code
  // returned from BE and native. Since these errors are returned from web bridge commands, there were no
  // way for FE to differentiate the errors.
  //
  // To fix this issue, Native-related error will use negative value; starting with
  // builds with passcode features. We're keeping the original value due to backward compatibility for build
  // with biometrics feature but without passcode features.
  ErrorLockoutTemporaryV2 = -10007,
  ErrorLockoutPermanentV2 = -10009,
  ErrorUserCancelledV2 = -10010,
  ErrorNegativeButtonV2 = -10013,

  // API related error
  ErrorBiometricsFeatureDisabled = 48401149,
  ErrorBiometricsDeactivated = 48401150,
  ErrorBiometricsVerificationFailed = 48401151,
  ErrorChallengeExpired = 48401152,
  ErrorBiometricsDataNotMatch = 48401153,
}

export enum BiometricType {
  Unknown = 0,
  TouchId = 1, // iOS
  Fingerprint = 2, // Android
  FaceId = 3,
  LockScreenPasscode = 4,
}

export enum BiometricScenario {
  Login = 1,
}

export { DeviceAuthenticatorType as BiometricReloginType, BiometricEntryPoint };
